module.exports = __webpack_public_path__ + "img/62.1.b0050c12.jpg";